// extracted by mini-css-extract-plugin
export default {"sector":"Sector_sector__VHSab","sectorContent":"Sector_sectorContent__holvl","prizeImage":"Sector_prizeImage__KRIW2","prizeLabel":"Sector_prizeLabel__gNAwI"};